module.exports = __webpack_public_path__ + "img/recharge(7).68aa220e.png";